export default __webpack_public_path__ + "static/media/PROSPECTUS-INFORMATION.fc2f1e94.pdf";